/**
 * Esquemas base reutilizables por todos los módulos (contracts.md §0).
 * Regla: Zod en el 100 % de los endpoints (body, query, params).
 */
import { z } from "zod";
import { ERROR_CODES, SURFACES } from "../enums.js";
/** ObjectId como string de 24 hex (contracts.md §0). */
export const objectId = z.string().regex(/^[0-9a-fA-F]{24}$/, "ObjectId inválido (24 hex)");
/** `Money` = entero de centavos ARS. Jamás decimales. (Se llama `moneySchema`
 * para no chocar con el constructor `money()` de `money.ts`.) */
export const moneySchema = z.number().int("Los importes van en centavos enteros").safe();
/** Fecha ISO-8601 (UTC) aceptada como string o Date, normalizada a Date. */
export const dateISO = z.coerce.date();
/** Fecha calendario `YYYY-MM-DD` (día operativo en zona AR). */
export const dateOnly = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Fecha esperada en formato YYYY-MM-DD");
/** Mes `YYYY-MM` (grillas, liquidaciones, convenios). */
export const yearMonth = z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, "Mes esperado YYYY-MM");
/** Hora `HH:mm`. */
export const timeHHmm = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Hora esperada HH:mm");
export const errorCode = z.enum(ERROR_CODES);
export const surface = z.enum(SURFACES);
/** Formato de error uniforme del contrato §0. */
export const errorResponse = z.object({
    error: z.object({
        code: errorCode,
        message: z.string(),
        details: z.unknown().optional(),
        /** La regla del AF que impidió la acción (`RULE_VIOLATION`). */
        rule: z.string().optional(),
    }),
});
/** Paginación `page/limit` del contrato §0. */
export const pagination = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(200).default(50),
    sort: z.string().optional(),
});
/** Toda lista operativa acepta `branchId` (D6). */
export const listQuery = pagination.extend({
    branchId: objectId.optional(),
    q: z.string().trim().min(1).max(120).optional(),
});
export function pageResponse(item) {
    return z.object({
        items: z.array(item),
        total: z.number().int().min(0),
        page: z.number().int().min(1),
        limit: z.number().int().min(1),
    });
}
/**
 * Motivo obligatorio de una excepción D5 (RN-ROL-11).
 * Todo endpoint que rompe una regla lo exige en el body, y el backend valida además
 * el rol mínimo de ESA excepción.
 */
export const reasonRequired = z
    .string()
    .trim()
    .min(5, "El motivo es obligatorio y tiene que explicar la excepción")
    .max(500);
/** Body de una acción excepcional: `{ reason }` más lo que agregue el endpoint. */
export const exceptionBody = z.object({ reason: reasonRequired });
/** Params `{ id }` de cualquier recurso. */
export const idParams = z.object({ id: objectId });
/** Rango de fechas de un reporte o filtro. */
export const dateRangeQuery = z.object({
    from: dateISO.optional(),
    to: dateISO.optional(),
});
export const exportFormat = z.enum(["csv", "xlsx"]);
//# sourceMappingURL=base.js.map